import {useI18n} from 'i18n/I18nContext'
import {useFormik} from 'formik'
import {useEventAttendants} from 'organization/Event/Attendants/EventAttendantsProvider'
import {useEventInvites} from 'organization/Event/Attendants/EventInvitesProvider'
import {useOrganizationEvent} from 'organization/Event/OrganizationEventProvider'
import React, {useEffect} from 'react'
import {toast} from 'react-toastify'

export const AddModal = (props: {show: boolean; toggle: () => void}) => {
  const {show, toggle} = props

  const {addAttendant, loading} = useEventAttendants()
  const {refresh} = useEventInvites()
  const {refreshEvent} = useOrganizationEvent()
  const {t} = useI18n()
  const {handleSubmit, handleChange, values, resetForm} = useFormik({
    initialValues: {
      email: '',
      reservation: false,
    },
    enableReinitialize: true,
    onSubmit: async (values: {email: string; reservation: boolean}) => {
      const result = await addAttendant(values.email, values.reservation)

      if (result === true) {
        toast.success(t('org.attendees.manualAddToast'))
        toggle()
      }

      if (typeof result === 'string') {
        toast.success(result)
        refresh()
        toggle()
      }

      refreshEvent()
    },
  })

  useEffect(() => {
    resetForm()
  }, [show, resetForm])

  return (
    <>
      <div
        onClick={toggle}
        className={`offcanvas__overlay ${show ? 'overlay-open' : ''}`}
      ></div>
      <section className={`speaker__popup-area ${show ? 'open' : ''}`}>
        <div className="popup__wrapper">
          <div className="popup__title-wrapper">
            <h3 className="popup__title">
              {t('org.attendees.manualAddTitle')}
            </h3>
          </div>
          <div className="popup__input-wrapper">
            <form onSubmit={handleSubmit}>
              <div className="singel__input-field mb-15">
                <label className="input__field-email">
                  {t('org.attendees.manualAddEmailLabel')} <br />
                  <span style={{fontSize: '0.8rem'}}>
                    {t('org.attendees.manualAddEmailNote')}
                  </span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  required
                />

                <div className="singel__input-field mb-35 mt-15">
                  <label className="input__field-text">
                    {t('org.attendees.manualAddReserveHint')}
                  </label>

                  <div className={`bd-theme-toggle `}>
                    <label
                      className="bd-theme-toggle-main"
                      style={{width: '100%'}}
                      htmlFor="add-attendee-reservation-toggle"
                    >
                      <span className={`bd-theme-toggle-dark `}>
                        {t('common.yes')}
                      </span>
                      <input
                        name="reservation"
                        type="checkbox"
                        id="add-attendee-reservation-toggle"
                        checked={values.reservation}
                        onChange={handleChange}
                      />
                      <i className="bd-theme-toggle-slide"></i>
                      <span className={`bd-theme-toggle-light `}>
                        {t('common.no')}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className={
                  loading ? 'disableBtnStyle w-100' : 'input__btn w-100'
                }
              >
                <i className="fa-regular fa-plus"></i>{' '}
                {t('org.attendees.manualAddSubmit')}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  )
}
